import DallasSvgIconVerifiedOutlined from '@ui/Dallas/Icons/DallasSvgIconVerifiedOutlined';
import DallasTooltipAnchor from '../../../../../_ui/Dallas/Tooltip/DallasTooltipAnchor';
import { useId } from 'react';

export default function FactorableBadge({
  tooltipText = 'Factorable',
}: {
  tooltipText?: string;
}) {
  const tooltipId = useId();

  return (
    <DallasTooltipAnchor
      tooltipType="label"
      tooltipId={tooltipId}
      tooltipPlacement="top"
      aria-labelledby={tooltipId}
      tooltip={tooltipText}
      render={(props) => (
        <DallasSvgIconVerifiedOutlined {...props} color="success" />
      )}
    />
  );
}
